<div class="title-bar">
  <ion-icon name="information-circle-outline" class="icon ion-hide-sm-down" />

  <h3>Zelfbeoordelingsvraag</h3>

  <ion-button
    color="medium"
    fill="clear"
    size="small"
    class="btn-close"
    (click)="dismiss()"
  >
    <ion-icon name="close" slot="icon-only" />
  </ion-button>
</div>

<div class="content">
  <p>
    Bij deze vraag kun je zelf jouw antwoord beoordelen. Kijk goed of jouw
    antwoord overeenkomt met het voorbeeldantwoord en of je het begrijpt.
  </p>

  <p>
    <ion-text color="success">Komt jouw antwoord goed overeen?</ion-text>
    Klik dan op het vinkje 'ik heb deze vraag goed beantwoord'.
  </p>

  <p>
    <ion-text color="danger">Heb je het antwoord fout?</ion-text>
    Dan laat je het vinkje leeg en ga je door naar de volgende vraag.
  </p>
</div>
